<template>
  <v-btn v-bind="attributes"
         v-on="$listeners"
         :color="color"
         :class="textShadowClass"
         class="white--text"
         raised>
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </v-btn>
</template>

<script>
const DEFAULTS = {
  elevation: 1
};

export default {
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'secondary'
    }
  },
  computed: {
    attributes () {
      return Object.assign({}, DEFAULTS, this.$attrs);
    },
    color () {
      let result = 'grey darken-1';
      if (this.type === 'primary')
      {
        result = 'primary';
      }
      else if (this.type === 'danger')
      {
        result = 'error';
      }

      return result;
    },
    textShadowClass () {
      if (this.$attrs.disabled === true)
      {
        return null;
      }

      let result = 'text-grey';
      if (this.type === 'primary')
      {
        result = 'text-primary';
      }
      else if (this.type === 'danger')
      {
        result = 'text-error';
      }

      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-primary {
  text-shadow: 1px 1px 1px darken($c-primary, 15%);
}
.text-error {
  text-shadow: 1px 1px 1px darken($c-error, 15%);
}
.text-grey {
  text-shadow: 1px 1px 1px darken(#757575, 15%);
}
</style>